import React from 'react';

const GoverningBodies: React.FC = () => {
  return (
    <section id="governing-bodies" className="governing-bodies">
      <div className="container">
        <div className="governing-bodies-header">
          <h2>Professional Standards & Registration</h2>
          <p className="governing-bodies-subtitle">
            PH Therapy clinicians are registered with the bodies that set and uphold standards for Clinical Exercise Physiologists in the UK.
          </p>
          <div className="governing-bodies-divider"></div>
        </div>

        <div className="governing-bodies-grid">
          <div className="governing-bodies-card">
            <div className="governing-bodies-card-icon">
              <i className="fas fa-university" aria-hidden="true"></i>
            </div>
            <h3><a href="https://www.clinicalexercisephysiology.org.uk/" target="_blank" rel="noopener noreferrer">CEP-UK</a> (Clinical Exercise Physiology UK)</h3>
            <div className="governing-bodies-card-content">
              <h4>Their role</h4>
              <p>CEP-UK is the professional governing body for Clinical Exercise Physiologists in the UK. They set standards for practice, develop curriculum frameworks for MSc programmes, and represent the profession.</p>
              <h4>What they do</h4>
              <p>CEP-UK accredits university degree programmes, defines scope of practice, works with AHCS on professional registration, and advocates for Clinical Exercise Physiology as a regulated healthcare profession.</p>
            </div>
          </div>

          <div className="governing-bodies-card">
            <div className="governing-bodies-card-icon">
              <i className="fas fa-shield-alt" aria-hidden="true"></i>
            </div>
            <h3><a href="https://www.ahcs.ac.uk/" target="_blank" rel="noopener noreferrer">AHCS</a> (Academy for Healthcare Science)</h3>
            <div className="governing-bodies-card-content">
              <h4>Their role</h4>
              <p>The Academy for Healthcare Science maintains PSA-accredited registers for healthcare scientists. Clinical Exercise Physiologists can join the register once they meet AHCS standards.</p>
              <h4>What they do</h4>
              <p>AHCS accredits education programmes, sets standards of proficiency and education, operates the Healthcare Science Practitioner register (PSA-accredited), and ensures accountability and fitness to practise.</p>
            </div>
          </div>
        </div>

        <div className="governing-bodies-perspectives">
          <div className="governing-bodies-perspective">
            <h4><i className="fas fa-user-tie" aria-hidden="true"></i> Practitioner perspective</h4>
            <p>Registration demonstrates qualification, ongoing professional development, and accountability to a regulatory body. It supports career progression, professional standing, and clear scope of practice. CEP-UK and AHCS provide guidance, standards, and a pathway to regulated healthcare status.</p>
          </div>
          <div className="governing-bodies-perspective">
            <h4><i className="fas fa-user-heart" aria-hidden="true"></i> Patient perspective</h4>
            <p>When you see an AHCS-registered Clinical Exercise Physiologist, you know they have met recognised standards and are accountable for their practice. Registration offers assurance of competence, evidence-based care, and a clear complaints process. It helps distinguish qualified CEPs from unregulated fitness providers, especially when managing complex or chronic conditions.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoverningBodies;
